import { actionTypes as FirebaseActions } from 'react-redux-firebase';

import { DEFAULT_CREATE_SEND_CRM_STATE } from '../../../constants/createSendCrm';
import { ICreateSendCrmState } from '../../../types/createSendCrm';
import * as AuthActions from '../../actions/auth';
import * as CrmActions from '../actions/crm';
import * as RecipientsActions from '../actions/recipients';

export const initialState: ICreateSendCrmState = DEFAULT_CREATE_SEND_CRM_STATE;

const withoutUid = (byRecipientUid: ICreateSendCrmState['byRecipientUid'], uid: string) => {
  const { [uid]: removed, ...rest } = byRecipientUid;

  return rest;
};

const reducer = (state: ICreateSendCrmState = initialState, action: any): ICreateSendCrmState => {
  switch (action.type) {
    case AuthActions.ADMIN_ROLE_CHANGED:
    case AuthActions.CHANGE_ORGANIZATION_SUCCESS:
    case FirebaseActions.LOGOUT:
    case RecipientsActions.RESET_CS_RECIPIENTS: {
      return initialState;
    }
    case CrmActions.SET_CS_PENDING_CRM_LINK: {
      return { ...state, pending: action.payload };
    }
    case CrmActions.CLEAR_CS_PENDING_CRM_LINK: {
      return { ...state, pending: null };
    }
    case CrmActions.COMMIT_CS_PENDING_CRM_LINK: {
      if (!state.pending) {
        return state;
      }

      return {
        ...state,
        byRecipientUid: { ...state.byRecipientUid, [action.payload.uid]: state.pending },
        pending: null,
      };
    }
    case CrmActions.CLEAR_CS_RECIPIENT_CRM_LINK: {
      return { ...state, byRecipientUid: withoutUid(state.byRecipientUid, action.payload.uid) };
    }
    case RecipientsActions.CS_REMOVE_RECIPIENT: {
      return { ...state, byRecipientUid: withoutUid(state.byRecipientUid, action.payload) };
    }
    case RecipientsActions.CS_CLEAR_RECIPIENTS: {
      return { ...state, byRecipientUid: {}, pending: null };
    }
    case CrmActions.SET_CS_SHIPMENT_CRM_LINK: {
      return { ...state, shipment: action.payload };
    }
    case CrmActions.SET_CS_CRM_OPPORTUNITY: {
      const { uid, opportunityId } = action.payload;

      if (uid === null) {
        return { ...state, shipment: state.shipment ? { ...state.shipment, opportunityId } : null };
      }

      const link = state.byRecipientUid[uid];

      return link
        ? { ...state, byRecipientUid: { ...state.byRecipientUid, [uid]: { ...link, opportunityId } } }
        : state;
    }
    default:
      return state;
  }
};

export default reducer;
